import React, { useEffect, useRef } from 'react';
import { runtime, Util } from 'codeArt/common';
import ReactEcharts from "echarts-for-react";
import echarts from 'echarts';
import { theme } from '../Base';

export default class BarSpreadChart extends React.Component {

    constructor(props) {
        super(props);
    }

    labelFormat(params, data) {

        let name = params.seriesName;
        if (name.indexOf('series') > -1) name = params.name;

        let value = params.value;
        let item = data.find((t) => { return t.type == name }) || {};

        let index = params.seriesIndex;
        let obj = item.format ? item.format(value, name, index) : { name, value };
        let marker = params.marker;

        return { marker, name: obj.name, value: obj.value, index }
    }


    getData(data) {
        let { barWidth, barMaxWidth } = this.props;

        let xData = []; //计算出坐标轴数据
        let tempData = []; //计算出临时分类数据 不过此时还没有进行转换
        let dataMaxLength = 0;

        data.forEach((t) => {
            xData.push(t.type);

            let l = [];
            let last = [0, 0];
            t.value.forEach((v) => {
                let interval = parseFloat((v[0] - last[1]).toFixed(2));  //计算出 这一次数据与上一次数据的间隔数据，间隔是不显示的
                l.push({ value: interval, hide: true, arrayValue: [last[1], v[0]] });

                interval = parseFloat((v[1] - v[0]).toFixed(2)); //计算出 这一次数据显示范围
                l.push({ value: interval, show: true, color: t.color, arrayValue: v });

                last = v;
            });

            tempData.push(l);
            if (l.length > dataMaxLength) dataMaxLength = l.length; //得到最长的分类数据长度
        });

        let seriesData = [];

        //根据最长的数据长度进行遍历
        for (let i = 0; i < dataMaxLength; i++) {
            let itemData = [];
            let itemArrayData = [];
            let hide = false;
            tempData.forEach((t) => {
                let temp = t[i];
                hide = temp.hide;
                itemData.push(temp.value);
                itemArrayData.push(temp.arrayValue || []);
            });

            let item = {
                type: 'bar',
                stack: '总量',
                data: itemData,
                arrayData: itemArrayData,
                barWidth: barWidth,
                barMaxWidth,
            };

            if (hide) {
                item.name = "hide";
                item.itemStyle = {
                    barBorderColor: 'rgba(0,0,0,0)',
                    color: 'rgba(0,0,0,0)'
                };
                item.emphasis = {
                    itemStyle: {
                        barBorderColor: 'rgba(0,0,0,0)',
                        color: 'rgba(0,0,0,0)'
                    }
                }
            } else {
                item.itemStyle = {
                    normal: {
                        color: function (params) {  //自定义柱状图 颜色
                            let item = data.find((t) => t.type == params.name);
                            return item.color || theme.color.primary;
                        }
                    }
                };

                item.label = {
                    show: false,
                }
            }
            seriesData.push(item);

        }
        return { xData, seriesData };
    }

    getOption() {
        let { data, tooltip, grid, title, line, lineType, y, x, label, horizontal, lineColor, tooltipFormat } = this.props;
        let option = {}; let my = this;

        let { xData, seriesData } = this.getData(data);


        if (title) {
            option.title = {
                text: title,
                textStyle: {
                    fontSize: 16,
                    fontWeight: 400,
                    color: theme.color.dark
                }
            }
        }

        if (tooltip) {
            option.tooltip = {
                trigger: 'item',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: function (params) {
                    let item = seriesData[params.seriesIndex];
                    let arry = item.arrayData[params.dataIndex];

                    let hide = params.seriesName == "hide";
                    let data = tooltipFormat ? tooltipFormat(arry, params.value, params.name, hide) : { value: params.value, name: params.name };
                    let tip = `${params.marker}${data.name} : ${data.value}`;

                    return tip;
                }
            }
        }

        option.grid = { left: '10', right: '25', bottom: '20', containLabel: true }; //自定义图表两边留空
        option.grid = Object.assign(option.grid, grid);


        let scaleAxis = {
            type: 'category',
            data: xData,
            name: horizontal ? y.name : x.name,
            axisTick: {
                alignWithLabel: true
            }
        }

        let dataAxis = {
            type: 'value',
            name: horizontal ? x.name : y.name,
            splitLine: {
                show: line, //网格线是否显示
                lineStyle: {
                    type: lineType, //网格线类型 solid：直线；dashed：短横线；dotted：点
                    color: lineColor,
                }
            },
            axisLine: { "show": true },
            axisTick: { "show": true },
            axisLabel: {
                formatter: function (value) {
                    let obj = horizontal ? x : y;
                    return obj.format ? obj.format(value) : value;
                }
            }
        }



        let xAxis = horizontal ? dataAxis : scaleAxis;
        option.xAxis = {
            ...xAxis,
            ...x
        }


        let yAxis = horizontal ? scaleAxis : dataAxis;
        option.yAxis = {
            ...yAxis,
            ...y
        }

        option.series = seriesData;


        return option;
    }

    render() {
        return <ReactEcharts option={this.getOption()} notMerge={true} lazyUpdate={true} height="auto" className={"w-100 h-100"} />
    }
}

BarSpreadChart.defaultProps = {
    y: { name: "" },
    x: { name: "" },
    data: [],
    barWidth: '60%',
    barMaxWidth: '60%',
    color: "#3398DB",
    lineColor: "#f0f0f0",
    tooltip: true,
    line: false,
    lineType: 'solid',
    horizontal: false,
}

BarSpreadChart.propTypes = {

};
